module.exports = __webpack_public_path__ + "za.svg?3c7ba32d93bb0417bfb1d8d0221d9d24";